import type { Repo } from '$lib/client/repo';

type ClientRepoState =
	| {
			status: 'noscript' | 'loading' | 'initializing' | 'connecting' | 'preparing';
			repo?: never;
			error?: never;
	  }
	| { status: 'error'; repo?: never; error: Error }
	| { status: 'ready'; repo: Repo; error?: never };

export const clientRepo = makeClientRepoState();

function makeClientRepoState() {
	let state: ClientRepoState = $state({ status: 'loading' });

	return {
		get status() {
			return state.status;
		},
		get repo() {
			return state.repo;
		},
		get error() {
			return state.error;
		},
		update(newState: ClientRepoState) {
			state = newState;
		}
	};
}
